
// @ts-nocheck


export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_998c0b20",
      load: () => import("#nuxt-i18n/998c0b20" /* webpackChunkName: "locale_en_46json_998c0b20" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_9c9b19aa",
      load: () => import("#nuxt-i18n/9c9b19aa" /* webpackChunkName: "locale_da_46json_9c9b19aa" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_dc3e7710",
      load: () => import("#nuxt-i18n/dc3e7710" /* webpackChunkName: "locale_de_46json_dc3e7710" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_5cf5ae40",
      load: () => import("#nuxt-i18n/5cf5ae40" /* webpackChunkName: "locale_es_46json_5cf5ae40" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_892e1cc9",
      load: () => import("#nuxt-i18n/892e1cc9" /* webpackChunkName: "locale_fi_46json_892e1cc9" */),
      cache: true
    }
  ],
  "fr-CA": [
    {
      key: "locale_fr_45CA_46json_4e90b984",
      load: () => import("#nuxt-i18n/4e90b984" /* webpackChunkName: "locale_fr_45CA_46json_4e90b984" */),
      cache: true
    }
  ],
  "fr-FR": [
    {
      key: "locale_fr_45FR_46json_94f49a00",
      load: () => import("#nuxt-i18n/94f49a00" /* webpackChunkName: "locale_fr_45FR_46json_94f49a00" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_2b827e4e",
      load: () => import("#nuxt-i18n/2b827e4e" /* webpackChunkName: "locale_it_46json_2b827e4e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_1da6e6a9",
      load: () => import("#nuxt-i18n/1da6e6a9" /* webpackChunkName: "locale_nl_46json_1da6e6a9" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_f1635a09",
      load: () => import("#nuxt-i18n/f1635a09" /* webpackChunkName: "locale_no_46json_f1635a09" */),
      cache: true
    }
  ],
  "pt-BR": [
    {
      key: "locale_pt_45BR_46json_10b50af4",
      load: () => import("#nuxt-i18n/10b50af4" /* webpackChunkName: "locale_pt_45BR_46json_10b50af4" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_9af325b5",
      load: () => import("#nuxt-i18n/9af325b5" /* webpackChunkName: "locale_pt_45PT_46json_9af325b5" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_a367f9df",
      load: () => import("#nuxt-i18n/a367f9df" /* webpackChunkName: "locale_sv_46json_a367f9df" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-CA",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fr-CA.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-FR",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-BR",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/pt-BR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt-PT",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/pt-PT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      files: [
        {
          path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/sv.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-CA",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fr-CA.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-FR",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-BR",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/pt-BR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt-PT",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/pt-PT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    files: [
      {
        path: "/tmp/workspace/staging/ghl-membership-frontend-clientportal/apps/clientportal/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/